import React, { useContext } from 'react';
import DealerAd from '../../../../DealerAd';
import { ThemeOptions, ThemeContext } from '@wix/da-react-context/pkg/ThemeContext';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { useInView } from 'react-intersection-observer';
import s from './Dealer.scss';
const REAL_ESTATE_ID_DARK = '150a7c06-b63c-40d0-9d26-7ce399ee49e9';
const REAL_ESTATE_ID_LIGHT = '856b5f3f-b93b-40cc-b7ba-66c8221a398a';
const REAL_ESTATE_ID_JSON = '13e4f7a8-0751-4e56-afd9-4cfac132acd1';
const Dealer = ()=>{
    const theme = useContext(ThemeContext);
    const dealer_json_offer = useFlag('dealer_json_offer');
    const { ref, inView } = useInView({
        threshold: 0
    });
    let realEstateId;
    if (dealer_json_offer) {
        realEstateId = REAL_ESTATE_ID_JSON;
    } else {
        realEstateId = theme === ThemeOptions.DARK ? REAL_ESTATE_ID_DARK : REAL_ESTATE_ID_LIGHT;
    }
    return /*#__PURE__*/ React.createElement("div", {
        ref: ref,
        className: s['root']
    }, inView && /*#__PURE__*/ React.createElement(DealerAd, {
        realEstateId: realEstateId,
        className: s['root']
    }));
};
Dealer.displayName = 'Dealer';
export default Dealer;
